<template>
  <layout :title="$route.name" :options="options" :toolbar_off="false">
    <div class="expande-horizontal wrap" style="z-index: 9999;">
      <span
        v-if="showWelcome"
        :class="{
          'white--text': dark,
          'black--text': !dark
        }"
        style="font-size: 22pt;"
        class="message fonte-bold animate__animated animate__fadeInUp"
        >Bem vindo(a)!</span
      >
      <v-flex v-if="false" xs12 class="pa-3 pb-0">
        <div class="expande-horizontal centraliza">
          <!-- <img
            class="img-logo"
            height="40"
            src="logo.jpeg"
            style="border-radius: 6px;"
          /> -->

          <v-spacer></v-spacer>
          <!-- <div class="expande-horizontal column title-item">
            <span style="font-size: 16pt;" class="fonte-bold">SCN</span>
            <span class="fonte grey--text">Bem vindo(a)</span>
          </div> -->
          <div>
            <!-- <v-avatar
              @click="$router.push('/logged-user')"
              size="31"
              style="cursor: pointer;"
              color="#555"
              icon
            >
              <v-icon size="21">mdi-account</v-icon>
            </v-avatar> -->
            <v-menu left offset-y rounded bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon v-if="!profile_image" color="blue"
                    >mdi-account-circle-outline</v-icon
                  >
                  <v-avatar v-else>
                    <v-img :src="profile_image"></v-img>
                  </v-avatar>
                </v-btn>
              </template>

              <v-list style="min-width: 300px;" class="fonte px-0 mx-0" dense>
                <v-list-item class="mx-0 px-2" to="/logged-user">
                  <v-avatar
                    v-if="!profile_image"
                    size="35"
                    color="#555"
                    class="mr-2"
                  >
                    <v-icon size="19">mdi-account-circle-outline</v-icon>
                  </v-avatar>
                  <v-avatar class="mr-2" size="35" v-else>
                    <v-img :src="profile_image"></v-img>
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      style="font-size: 11pt;"
                      class="fonte-bold"
                      >Meu perfil</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      getLoggedUser.name
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="mx-0 px-2" to="/config">
                  <v-avatar size="35" color="#555" class="mr-2">
                    <v-icon size="19">mdi-cog-outline</v-icon>
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      style="font-size: 11pt;"
                      class="fonte-bold"
                      >Configurações</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >Foto de perfil e senha.</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout" class="mx-0 px-2">
                  <v-avatar size="35" color="#555" class="mr-2">
                    <v-icon size="19">mdi-run</v-icon>
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      style="font-size: 11pt;"
                      class="fonte-bold"
                      >Sair</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >desconecta a sua conta</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- <span class="fonte-bold text-uppercase">
              {{  firstName  }}
            </span> -->
          </div>
        </div>
      </v-flex>
      <!-- <v-flex xs12 class="pa-6 pb-0">
        <v-alert type="success">
          Mensagem fixa
        </v-alert>
      </v-flex> -->

      <!-- <v-flex
        xs12
        md12
        :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6 mb-6'"
      >
        <ChartSaldo />
      </v-flex> -->
      <!-- <v-flex xs12 md6 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6' ">
                <ChartSaldo />
            </v-flex> -->
      <!-- <v-flex xs12>
        <div
          :class="{ centraliza:  $vuetify.breakpoint.smAndDown }"
          class="expande-horizontal pa-3"
        >
          <Graduacao />
        </div>
      </v-flex> -->
      <v-flex class="animate__animated animate__fadeIn animate__delay-2s" xs12>
        <div class="expande-horizontal wrap pa-3 px-3">
          <v-flex  xs12>
            <h2 class="fonte-bold white--text pa-2">🍀 Resumo</h2>
          </v-flex>
          <v-flex xs12 class="">
            <div class="expande-horizontal wrap">
              <!-- <v-flex
                :class="{
                  'py-2 mb-3': !$vuetify.breakpoint.lgAndUp,
                  'pa-0':  $vuetify.breakpoint.lgAndUp
                }"
                xs12
                md3
                 
                style="max-height: 250px;"
              >

              </v-flex> -->
              <v-flex
                xs12
                md3
                :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'px-3'"
              >
                <SaldoRentabilidade />
              </v-flex>
              <v-flex
                xs12
                md3
                :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'px-3'"
              >
                <SaldoInvestimento />
              </v-flex>
              <v-flex
                :class="{
                  'px-2':  $vuetify.breakpoint.lgAndUp,
                  'py-2 px-3': !$vuetify.breakpoint.lgAndUp
                }"
                xs12
                class="pa-0"
                md6
                
              >
                <v-card
                  style="border-radius: 12px; min-height: 250px; max-height: 250px;"
                  :color="dark ? '#555' : '#555'"
                  :dark="dark"
                  class="pa-2 pl-0 pt-0 card-style expande-horizontal column animate__animated animate__fadeIn"
                >
                  <h2 class="fonte-bold ma-2 white--text">
                    📈 Rentabilidade
                  </h2>
                  <Chart
                    :dark="false"
                    type="line"
                    v-if="showCharts"
                    ref="chartSales"
                    backgroundColor="rgba(245, 175, 25, 0.514)"
                    description="Rentabilidade"
                    :labels="salesLast30Days.days"
                    :dataChart="salesLast30Days.valuesForDays"
                    :id="'chart-2'"
                    :height="200"
                  />
                </v-card>
              </v-flex>
            </div>
          </v-flex>
          <!-- <div
            @click="$router.push('/pagar/unilevel')"
            class="centraliza column mr-4"
            style="display: flex; width: 60px;"
          >
            <div
              class="centraliza"
              style="border-radius: 12px; background-color: #555; display: flex; width: 60px; height: 60px;"
            >
              <v-icon size="30">mdi-account-key-outline</v-icon>
            </div>
            <span class="fonte-bold black--text">Autenticar</span>
          </div> -->
          <!-- <div
            @click="$router.push('/transferencia/unilevel')"
            class="centraliza column mr-4"
            style="display: flex; width: 60px;"
          >
            <div
              class="centraliza"
              style="border-radius: 12px; background-color: #555; display: flex; width: 60px; height: 60px;"
            >
              <v-icon size="30">mdi-cash-fast</v-icon>
            </div>
            <span class="fonte-bold black--text">Transferência</span>
          </div> -->
          <!-- <div
            @click="$router.push('/transactions')"
            class="centraliza column mr-4"
            style="display: flex; width: 60px;"
          >
            <div
              class="centraliza"
              style="border-radius: 12px; background-color: #555; display: flex; width: 60px; height: 60px;"
            >
              <v-icon color="white" size="30">mdi-receipt-text-outline</v-icon>
            </div>
            <span class="fonte-bold black--text">Extratos</span>
          </div> -->
          <!-- <div
            @click="$router.push('/deposito/unilevel')"
            class="centraliza column mr-4"
            style="display: flex; width: 60px;"
          >
            <div
              class="centraliza"
              style="border-radius: 12px; background-color: #555; display: flex; width: 60px; height: 60px;"
            >
              <v-icon color="white" size="30">mdi-cash-plus</v-icon>
            </div>
            <span class="fonte-bold black--text">Depósito</span>
          </div> -->
          <!-- <div
            @click="$router.push('/careers')"
            class="centraliza column mr-4"
            style="display: flex; width: 60px;"
          >
            <div
              class="centraliza"
              style="border-radius: 12px; background-color: #555; display: flex; width: 60px; height: 60px;"
            >
              <v-icon color="white" size="30">mdi-account-tie-outline</v-icon>
            </div>
            <span class="fonte-bold black--text">Licenças</span>
          </div> -->
          <!-- <div
            @click="$router.push('/estabelecimentos')"
            class="centraliza column mr-1"
            style="display: flex; width: 60px;"
          >
            <div
              class="centraliza"
              style="border-radius: 12px; background-color: #555; display: flex; width: 60px; height: 60px;"
            >
              <v-icon size="30">mdi-storefront</v-icon>
            </div>
            <span class="fonte-bold black--text">Empresas</span>
          </div> -->
          <!-- <div @click="$router.push('/solicitar-pagamento/unilevel')" class="centraliza column mr-3" style="display: flex; width: 60px;">
            <div
              class="centraliza"
              style="border-radius: 12px; background-color: #555; display: flex; width: 60px; height: 60px;"
            >
              <v-icon size="30">mdi-cash-register</v-icon>
            </div>
            <span class="fonte-bold">Receber</span>
          </div> -->
          <!-- <div @click="$router.push('/estabelecimentos')" class="centraliza column" style="display: flex; width: 60px;">
            <div
              class="centraliza"
              style="border-radius: 12px; background-color: #555; display: flex; width: 60px; height: 60px;"
            >
              <v-icon size="30">mdi-storefront-outline</v-icon>
            </div>
            <span class="fonte-bold">Empresas</span>
          </div> -->
        </div>
      </v-flex>
      <v-flex
        
        class="animate__animated animate__fadeIn animate__delay-2s"
        xs12
      >
        <div class="expande-horizontal wrap pa-3 px-0">
          <v-flex xs12>
            <h2 class="fonte-bold white--text px-6">🪙 Meus Planos de Investimento</h2>
          </v-flex>

          <!-- <v-flex
            v-if="show_unilevel"
            xs12
            md3
            :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'px-3'"
          >
            <SaldoPL />
          </v-flex> -->
          <!-- <v-flex
            v-if="show_unilevel"
            xs12
            md3
            :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'px-3'"
          >
            <SaldoDisponivel />
          </v-flex> -->
          
        </div>
      </v-flex>
      <v-flex
        class="animate__animated animate__fadeIn animate__delay-2s"
        xs12
      >
        <div v-if="false" class="expande-horizontal wrap pa-3 px-0">
          <v-flex xs12>
            <h3 class="fonte-bold white--text px-6">🎓 Unilevel</h3>
          </v-flex>
          <v-flex
            xs12
            md4
            :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'px-3'"
          >
            <Link />
          </v-flex>
          <!-- <v-flex
            xs12
            md4
            :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'px-3'"
          >
            <Binario />
          </v-flex> -->
          <v-flex
            v-if="show_unilevel"
            xs12
            md4
            :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'px-3'"
          >
            <Unilevel />
          </v-flex>
        </div>
      </v-flex>

      <!-- <v-flex class="px-3" xs12>
        <h3 class="fonte-bold black--text px-3">Operações</h3>
      </v-flex> -->
      <div class="expande-horizontal wrap px-3">
        <v-flex
          class="pa-3 animate__animated animate__fadeIn animate__delay-2s"
          v-for="purchase in getPurchases"
          v-show="purchase.purchase_type == 'investment'"
          :key="purchase._id"
          xs12 md4
        >
          <v-card dark style="border-radius: 16px;" class="card-balance-style pa-2 pt-0">
            <v-flex xs12>
              <div class="expande-horizontal wrap column">
                <div class="expande-horizontal pa-1">
                  <v-list class="pa-0 ma-0" color="transparent">
                    <v-list-item class="pa-0 ma-0">
                      <v-avatar color="orange" class="mr-2" size="35">
                        <v-icon color="black">mdi-cash</v-icon>
                      </v-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          {{ purchase.item.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ purchase.item.description }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          dark
                          v-if="$vuetify.breakpoint.lgAndUp"
                          class="elevation-0 black--text"
                          :color="getColorByPurchaseProgress(purchase)"
                          x-small
                        >
                          <span class="fonte-bold mr-1">
                            {{
                              purchase.current_status === "active"
                                ? "ativo |"
                                : purchase.current_status
                            }}
                          </span>
                          <span class="fonte-bold" v-if="purchase.total_percent_gained">
                            {{ parseFloat(purchase.total_percent_gained) }} 
                            <!-- de
                            {{ purchase.item.total_percent_gain }} -->
                            %
                          </span>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <!-- <v-spacer></v-spacer> -->
                </div>
                <div class="expande-horizontal centraliza px-3 pb-3" style="gap: 6px;">
                  <v-chip v-if="$moment(purchase.item.next_reset_circle).fromNow().includes('há')" class="fonte-bold black--text" color="orange" small>
                    🪙
                    O Último resgate foi {{ $moment(purchase.item.next_reset_circle).fromNow()}}
                  </v-chip>
                  <v-chip v-else class="fonte-bold black--text" color="orange" small>
                    🪙
                    Próximo resgate: {{ $moment(purchase.item.next_reset_circle).fromNow()}}
                  </v-chip>
                </div>
                <div class="my-2 expande-horizontal centraliza" v-if="purchase.item.restant_cicles">
                  <v-chip style="border-radius: 6px;" color="green" class="fonte px-1 mr-1" v-for="n in (12 - purchase.item.restant_cicles)" :key="n">
                    {{ n }}
                    <v-icon>mdi-check-all</v-icon>
                  </v-chip>
                  <v-chip style="border-radius: 6px;" :outlined="i === 0 ? false : true" :color="i === 0 ? 'blue' : 'grey darken-1'" :dark="i === 0 ? false : true" class="px-1 fonte mr-1" v-for="(n, i) in purchase.item.restant_cicles" :key="n">
                    {{ n + (12 - purchase.item.restant_cicles) }}
                    <v-icon v-if="i === 0">mdi-check</v-icon>
                    <v-icon v-else>mdi-clock-outline</v-icon>
                  </v-chip>
                </div>
                <div class="expande-horizontal" style="background: #444; padding: 3px;">
                  <v-progress-linear
                    :color="getColorByPurchaseProgress(purchase)"
                    height="15"
                    style="border-radius: 56px;"
                    stream
                    :value="purchase.total_percent_gained / 2.4"
                    :buffer-value="purchase.total_percent_gained / 2.4"
                    striped
                  >
                    <template v-slot:default="{ value }">
                      <span class="white--text font-weight-bold"
                        >{{ parseFloat(purchase.total_percent_gained) }} de
                        {{ purchase.item.total_percent_gain }}%
                      </span
                      >
                    </template>
                  </v-progress-linear>
                </div>
                <!-- <div class="pa-3 pb-1 pt-0 expande-horizontal">
                  <v-icon class="mr-1" color="orange" size="11">mdi-star</v-icon>
                  <span style="font-size: 9pt;;" class="fonte orange--text">
                    Dia de saque: {{ $moment(purchase.due_date).format("DD") }} +
                    3 dias subsequentes
                  </span>
                </div> -->
                <div class="pa-3 px-0 pb-1 pt-0 expande-horizontal">
                  <v-timeline dense class="px-0">
                    <v-timeline-item
                      color="orange"
                      small
                      v-for="status in purchase.status"
                      :key="status"
                    > 
                      <span class="fonte"> {{ status.status }}</span>
                      <span class="grey--text fonte"> ({{ $moment(status.date).format('DD/MM/YYYY [às] HH:mm') }}) </span>
                    </v-timeline-item>
                    <v-timeline-item
                      color="blue"
                      icon="mdi-information-outline"
                    >
                      <div class="pt-2 expande-horizontal column">
                        <span class="fonte grey--text">Tipo de Recebimento: <span class="font-weight-bold white--text">{{ purchase.receive_type }}</span> </span>
                        <span class="grey--text fonte" v-if="purchase.receive_type == 'mensal'"> por 12 meses </span>
                      </div>
                    </v-timeline-item>
                    <v-timeline-item
                      v-if="purchase.item && purchase.item.next_reset_circle"
                      color="green"
                      icon="mdi-flag-outline"
                    >
                      <div class="pt-2">
                        <span class="fonte grey--text mt-3 pt-3">Próximo Resgate: </span>
                        <span class="fonte font-weight-bold"> {{ $moment(purchase.item.next_reset_circle).format('DD/MM/YYYY') }} </span>
                      </div>
                      <!-- <v-avatar><v-icon color="green">mdi-flag-outline</v-icon></v-avatar> -->
                    </v-timeline-item>
                    <!-- <v-timeline-item
                      v-if="purchase.item && purchase.item.restant_cicles"
                      color="orange"
                      icon="mdi-information-outline"
                    >
                      <div class="pt-2 expande-horizontal column">
                        <span class="fonte mt-3 pt-3">Ciclos Restantes ({{ purchase.receive_type }}) </span>
                        <span class="grey--text fonte"> {{ purchase.item.restant_cicles - 1 }} </span>
                      </div>
                    </v-timeline-item> -->
                  </v-timeline>
                  <!-- <span
                    style="font-size: 18pt;"
                    class="my-4 font-weight-bold green--text"
                  >
                    Saldo: R$
                    {{ $toLocaleString(purchase.withdraw_available_value || 0) }}
                  </span> -->
                </div>
                <!-- <div class="pa-3 pb-1 pt-0 expande-horizontal">
                  <span style="font-size: 9pt;;" class="fonte red--text">
                    Saques: R$
                    {{ $toLocaleString(purchase.withdraw_available_fired || 0) }}
                  </span>
                </div> -->
              </div>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex
          :class="{
            'pa-2': !$vuetify.breakpoint.lgAndUp
          }"
          class="pa-3 animate__animated animate__fadeIn animate__delay-2s"
          xs12
          md3
        >
          <Subscription />
        </v-flex>
      </div>
      <!-- <v-flex
        v-if="show_unilevel"
        xs12
        md6
        :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-3'"
      >
        <SaldoContabil />
      </v-flex> -->
      <!-- <v-flex
        v-if="show_token"
        xs12
        md4
        :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'"
      >
        <Tokens />
      </v-flex> -->
      <!-- <v-flex v-if="show_unilevel" xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'">
        <PlanoDeCarreira />
      </v-flex> -->

      <!-- <v-flex xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'">
        <Notificacoes />
      </v-flex> -->
      <!-- <v-flex
        v-if="getLoggedUser.primeira_compra"
        xs12
        md4
        :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'"
      > -->

      <!-- <v-flex
        v-if="show_unilevel"
        xs12
        md6
        :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-3'"
      >
        <QtdEmpresas />
      </v-flex> -->
      <!-- <v-flex
        v-if="show_unilevel"
        xs12
        md6
        :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-3'"
      >
        <LinkEmpresarial />
      </v-flex> -->
      <!-- <v-flex xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'">
        <TotalGain />
      </v-flex> -->
      <!-- <v-flex v-if="show_unilevel" xs12 md4 :class="$vuetify.breakpoint.smAndDown ? 'pa-3' : 'pa-6'">
        <PlanExpiresIn />
      </v-flex> -->
      <v-dialog style="border-radius: 12px;" width="300" v-model="modal_unread">
        <v-flex xs12>
          <v-card class="expande-horizontal wrap">
            <v-flex class="pa-3" xs12>
              <div class="expande-horizontal centraliza">
                <v-icon color="green"> mdi-bell-ring </v-icon>
              </div>
            </v-flex>
            <v-flex xs12>
              <h3 class="fonte text-center pa-3">
                {{ total_unreads }} notificações não lidas
              </h3>
            </v-flex>
            <v-flex xs12>
              <div class="expande-horizontal fonte pa-3 centraliza wrap">
                <v-btn
                  color="orange"
                  @click="$router.push('/notifications')"
                  >Ir para notificações</v-btn
                >
              </div>
            </v-flex>
          </v-card>
        </v-flex>
      </v-dialog>
    </div>
  </layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Subscription from "./components/Subscription";
import Saldo from "./components/Saldo";
import SaldoPL from "./components/SaldoPL";
import SaldoDisponivel from "./components/SaldoDisponivel";
import SaldoContabil from "./components/SaldoContabil";
import PlanoDeCarreira from "./components/PlanoDeCarreira";
import SaldoInvestimento from "./components/SaldoInvestimento.vue";
import SaldoRentabilidade from "./components/SaldoRentabilidade.vue";
import Tokens from "./components/Tokens";
import Unilevel from "./components/Unilevel";
import Binario from "./components/Binario";
import Notificacoes from "./components/Notificacoes";
// import ChartSaldo from "./components/ChartSaldo";
import Link from "./components/Link";
import PlanExpiresIn from "./components/PlanExpiresIn";
import Graduacao from "./components/Graduacao";
import TotalGain from "./components/TotalGain";
import LinkEmpresarial from "./components/LinkEmpresarial";
import QtdEmpresas from "./components/QtdEmpresas";
import Chart from "./components/Chart.vue";

export default {
  data() {
    return {
      options:[],
      dark: true,
      showWelcome: true,
      showCharts: false,
      // show_unilevel: process.env.VUE_APP_LOJA_UNILEVEL,
      show_unilevel: true,
      show_token: process.env.VUE_APP_LOJA_TOKEN,
      show_ativos: process.env.VUE_APP_LOJA_ATIVOS,
      modal_unread: false,
      total_unreads: 0
    };
  },
  components: {
    Graduacao,
    Saldo,
    SaldoDisponivel,
    SaldoContabil,
    PlanoDeCarreira,
    Tokens,
    Unilevel,
    Notificacoes,
    // ChartSaldo,
    Link,
    PlanExpiresIn,
    TotalGain,
    LinkEmpresarial,
    QtdEmpresas,
    Binario,
    Subscription,
    SaldoInvestimento,
    SaldoRentabilidade,
    Chart,
    SaldoPL
  },
  computed: {
    ...mapGetters([
      "getDashboard",
      "getLoggedUser",
      "getPurchases",
      "get_notifications",
      "getBalanceUnilevel",
      "getBalanceInvestment",
      "getBalancePL",
      "getInvestiments"
    ]),
    balances() {
      return [
        // 0,
        this.getBalanceUnilevel.balance || 0,
        this.getBalanceInvestment.balance || 0,
        this.getBalancePL.balance || 0
        // 0
      ];
    },
    salesLast30Days() {
      let sales = this.getBalanceInvestment.extract_locked || [];
      // let limit = this.$moment().subtract(30, "days").format("YYYY-MM-DD");
      // let salesLast30Days = sales.filter(sale => {
      //   return this.$moment(sale.created_at).format("YYYY-MM-DD") >= limit;
      // })
      let days = [];
      let valuesForDays = [];
      for (let i = 30; i > 0; i--) {
        let day = this.$moment()
          .subtract(i, "days")
          .format("DD/MM");
        let salesForDay = sales.filter(
          sale => this.$moment(sale.created_at).format("DD/MM") === day
        );

        days.push(day);
        valuesForDays.push(salesForDay.length ? salesForDay[0].value : 0);
      }
      return {
        days,
        valuesForDays
      };
    },
    profile_image() {
      const user = JSON.parse(localStorage.getItem("user"));
      const img_profile = user ? user.profile_image : false;
      return user ? img_profile : this.getLoggedUser.profile_image || "";
    },
    firstName() {
      if (this.getLoggedUser) {
        return this.getLoggedUser.name.split(" ")[0];
      }
      return "";
    }
  },
  methods: {
    ...mapActions([
      "listBalanceInvestment",
      "listBalanceToken",
      "listBalanceUnilevel",
      "listBalancePL",
      "listar_notifications",
      "listPurchases",
      "listUnilevels",
      "listInvestments",
      "openPurchase",
      "logout"
    ]),
    getColorByPurchaseProgress(purchase) {
      if (purchase.total_percent_gained === purchase.item.total_percent_gain) {
        return "green";
      }

      if (
        purchase.total_percent_gained &&
        purchase.total_percent_gained < purchase.item.total_percent_gain
      ) {
        return "orange";
      }

      if (purchase.total_percent_gained === 0) {
        return "red";
      }
    },
    isReaded(item) {
      const isArray = Array.isArray(item.readed);
      if (isArray) {
        return item.readed.includes(this.getLoggedUser._id);
      } else {
        return item.readed
      }
    },
    verifyNotifications(notifications) {
      let total_unreads = 0;
      
      notifications.map(notify => {
        if (!this.isReaded(notify)) {
          total_unreads += 1;
        }
      });

      if (total_unreads > 0 && (total_unreads != sessionStorage.total_unreads)) {
        this.total_unreads = total_unreads;
        this.modal_unread = true;
        sessionStorage.total_unreads = total_unreads;
      }
    }
  },
  created() {
    let quiet = true;
    this.listBalanceInvestment(quiet);
    this.listBalanceToken(quiet);
    this.listBalanceUnilevel(quiet);
    this.listBalancePL(quiet);
    this.listUnilevels(quiet);
    this.listPurchases(quiet);
    this.listInvestments(quiet);
  },
  async mounted() {
    let quiet = true;

    setTimeout(() => {
      this.showCharts = true;
    }, 3000);
    setTimeout(() => {
      this.showWelcome = false;
    }, 2300);
    this.listar_notifications(quiet).then((notifications) => {
      const n = notifications.docs;
      this.verifyNotifications(n);
    });
  }
};
</script>

<style>
.message {
  width: 150px;
  /* animation: digitando 0.2s ease; */
  white-space: nowrap;
  overflow: hidden;

  position: absolute;
  top: 50%;
  left: 45%;
  /* transform: translate(-50%, -50%); */
}
.card-graduation {
  background: #232526; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #414345,
    #232526
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #414345,
    #232526
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.img-logo {
  filter: invert(97%);
}
</style>
